import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, ArrowRight, CheckCircle } from 'lucide-react';
import FloatingCards from './FloatingCards';
import ContactForm from './ContactForm';
import BookingModal from './BookingModal';
import SchemaMarkup from './SchemaMarkup';
import { clinicInfo } from '../data/servicesData';
import { Helmet } from 'react-helmet';

const ServicePageTemplate = ({ pageData }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  if (!pageData) {
    return <div>Page not found</div>;
  }

  return (
    <div className="service-page">
      <Helmet>
        <title>{pageData.title}</title>
        <meta name="description" content={pageData.intro} />
      </Helmet>
      <SchemaMarkup pageData={pageData} />

      <section className="service-hero-section">
        <div className="hero-layout">
          <div className="hero-left">
            <FloatingCards cards={pageData.floatingCards} />
          </div>
          
          <div className="hero-right">
            <div className="service-hero-content">
              <h1 className="service-h1">{pageData.h1}</h1>
              <h2 className="service-h2">{pageData.h2}</h2>
              <p className="service-intro">{pageData.intro}</p>

              <div className="service-cta-buttons">
                <a href={`tel:${clinicInfo.phone}`} className="cta-button primary">
                  <Phone size={20} />
                  <span className="btn-text-full">Call {clinicInfo.phone}</span>
                  <span className="btn-text-short">Call Now</span>
                </a>
                <button onClick={() => setIsModalOpen(true)} className="cta-button secondary">
                  <span className="btn-text-full">Book Consultation</span>
                  <span className="btn-text-short">Book Now</span>
                  <ArrowRight size={20} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {pageData.benefits && (
        <section className="service-benefits-section">
          <div className="section-container">
            <div className="section-header">
              <h2>Benefits</h2>
            </div>
            <div className="benefits-grid">
              {pageData.benefits.map((benefit, index) => (
                <div key={index} className="benefit-item">
                  <CheckCircle className="benefit-icon" size={20} />
                  <span>{benefit}</span>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {pageData.process && (
        <section className="service-process-section">
          <div className="section-container">
            <div className="section-header">
              <h2>Treatment Process</h2>
            </div>
            <div className="process-steps">
              {pageData.process.map((step, index) => (
                <div key={index} className="process-step">
                  <div className="step-number">{index + 1}</div>
                  <p>{step}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      <section className="service-why-choose-section">
        <div className="section-container">
          <div className="section-header">
            <h2>Why Choose Dr. Thamarai's Dental Care in East Tambaram?</h2>
          </div>
          <div className="why-choose-grid">
            <div className="why-choose-item">
              <h3>10+ Years of Expertise</h3>
              <p>Experienced dentists with proven track record in advanced dental treatments.</p>
            </div>
            <div className="why-choose-item">
              <h3>Modern Equipment</h3>
              <p>State-of-the-art dental technology for precise and comfortable treatments.</p>
            </div>
            <div className="why-choose-item">
              <h3>Patient-Centric Care</h3>
              <p>Personalized treatment plans tailored to your unique dental needs.</p>
            </div>
            <div className="why-choose-item">
              <h3>Convenient Location</h3>
              <p>Easily accessible dental clinic in East Tambaram, Chennai with ample parking.</p>
            </div>
          </div>
        </div>
      </section>

      {pageData.faqs && (
        <section className="service-faq-section">
          <div className="section-container">
            <div className="section-header">
              <h2>Frequently Asked Questions</h2>
            </div>
            <div className="faq-list">
              {pageData.faqs.map((faq, index) => (
                <div key={index} className="faq-item">
                  <h3>{faq.q}</h3>
                  <p>{faq.a}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      <BookingModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        pageTitle={pageData.h1}
      />
    </div>
  );
};

export default ServicePageTemplate;
